import { GET_WEBMASTER_DASHBOARD, GET_CTRL_ALL_COMPLAINTS } from '../../index.types';

export function getWebmasterDashboard(data) {
    return {
        type: GET_WEBMASTER_DASHBOARD,
        data,
    };
}

export function getCtrlAllComplaints(data) {
    return {
        type: GET_CTRL_ALL_COMPLAINTS,
        data,
    };
}
